if( $('#pagina-rankings').length ) {

    var vmRankings = new Vue({
        el: '#pagina-rankings',
        data: {
            tabs        : ['atual', 'historico', 'simulados'],
            tabAtiva    : 'atual',
            ano         : -1,
            mes         : -1,
            atual       : {},
            historico   : {},
            simulados   : {},
            carregado   : {
                atual       : false,
                historico   : false,
                simulados   : false
            }
        },
        methods: {
            exibirTab: function ( nome_tab ) {
                location.hash = '/' + nome_tab;
            },
            carregaTab: function ( tabNome ) {

                var self = this;

                ajaxGET(
                    '/rankings/carregar',
                    { tab: tabNome, ano: this.ano, mes: this.mes },
                    function (dados) {
                        Vue.set(self, tabNome, dados.ranking);
                        self.carregado[ tabNome ] = true;

                        if( dados.hasOwnProperty('mes') ){
                            self.mes = dados.mes;
                            self.ano = dados.ano;
                        }

                        Vue.nextTick(inicializaTooltips);
                    }
                );
            },
            verificaHash: function ( ) {

                var tabNome = (location.hash).substr(2);

                if( this.tabs.indexOf(tabNome) == -1 ){
                    return location.hash = '/atual';
                }

                if( ! this.carregado[ tabNome ] ){
                    this.carregaTab( tabNome );
                }

                this.tabAtiva = tabNome;
            }
        },
        created: function () {

            this.verificaHash();
        }
    });

    /* SIMPLE JAVASCRIT ROUTER - BY RONI RIGONI */
    $(window).on('hashchange', function () {
        vmRankings.verificaHash();
    });

    vmRankings.$watch('ano*mes', function ( newVal, oldVal ) {
        if( (oldVal != 1) && (newVal != oldVal) ){
            vmRankings.carregaTab('historico');
        }
    });

}
